package org.matthewo.components

import io.ktor.client.call.*
import io.ktor.client.request.*
import js.coroutines.awaitCancellation
import js.objects.unsafeJso
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.matthewo.client
import org.matthewo.styles.css
import react.*
import react.dom.events.MouseEvent
import react.dom.html.ReactHTML.div
import web.html.HtmlSource

external interface SVGProps : PropsWithClassName {
    var url: String?
    var onClick: ((MouseEvent<*, *>) -> Unit)?
}

val SVG = FC<SVGProps> { props ->
    val coroutineScope = useMemo { CoroutineScope(Dispatchers.Main) }

    var svg by useState<String>()

    useEffect(props.url) {
        val job = coroutineScope.launch {
            svg = props.url?.let { client.get(it).body() }
        }
        awaitCancellation { job.cancel() }
    }

    div {
        css(props.className)
        onClick = { props.onClick?.invoke(it) }
        val svg = svg
        if (null != svg) {
            dangerouslySetInnerHTML = unsafeJso { asDynamic().__html = HtmlSource(svg) }
        }
    }
}
